import type { LeagueRoundPreview as Preview } from "@tnp/contracts";
import { getLeagueRosterTexts } from "../../shared/leagueRosterTexts";
import LeagueFeedback from "../../shared/components/LeagueFeedback";

export default function LeagueRoundPreview({ preview }: { preview: Preview }) {
  const t = getLeagueRosterTexts();
  if (preview.totalPlayers === 0) return null;
  return <section className="league-preview">
    <h2>{t.preview}</h2>
    <p>{t.total} {preview.totalPlayers}</p>
    {!preview.ready ? <LeagueFeedback>{t.incomplete} {preview.missingPlayers}</LeagueFeedback> : <>
      <div className="league-grid">{preview.groups.map(group => {
        const name = (id: number) => group.players.find(player => player.userId === id)?.name || String(id);
        return <article className="league-panel" key={group.label}>
          <h3>{t.group} {group.label}</h3>
          <ol>{group.players.map(player => <li key={player.userId}>{player.name}</li>)}</ol>
          <p>{t.schedule} {name(group.schedulingUserId)}</p>
          <p>{t.fallback} {name(group.fallbackSchedulingUserId)}</p>
          <ol className="league-match-list">{group.matches.map(match => <li key={match.number}>
            <strong>{t.game} {match.number}</strong><span>{match.leftUserIds.map(name).join(" + ")} × {match.rightUserIds.map(name).join(" + ")}</span>
          </li>)}</ol>
        </article>;
      })}</div>
    </>}
  </section>;
}
